/*jshint esversion: 9 */
// import { mapGetters, mapActions } from 'vuex';

export const BacklogMixin = {
  components: {
  },
  data: () => ({

  }),
  computed: {
    // ...mapGetters('View', [
    //   'is_show_side_bar'
    // ]),
  },
  methods: {
    getWBWorkpackageDate(wbworkpackage, project_id) {
      // console.log(wbworkpackage);
      if (this.getCalendar(project_id).takt_times.length === 0) {
        return false;
      }
      let date = {
        start: '',
        end: '',
      };
      if (wbworkpackage.position !== -1) {
        let dates = this.getCalendar(project_id).takt_times[wbworkpackage.position-1].dates;
        let start = dates[0].toISOString().substring(0,10);
        if (wbworkpackage.length > 1 && this.getCalendar(project_id).takt_times[parseInt(wbworkpackage.position-1) + parseInt(wbworkpackage.length) - 1]) {
          dates = this.getCalendar(project_id).takt_times[parseInt(wbworkpackage.position-1) + parseInt(wbworkpackage.length) - 1].dates;
        }
        let end = dates[dates.length-1].toISOString().substring(0,10);
        if (start) {
          date.start = start;
        }
        if (end) {
          date.end = end;
        }
      }
      return date;
    }
    // ...mapActions('View', [
    //   'setShowSideBar'
    // ]),
  }
};
